import { IonContent, IonItem, IonLabel, IonModal } from "@ionic/react";
import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";

const objectSets = [
    ["🍎", "🍌", "🍇"], ["🚗", "🚌", "🚲"], ["🏀", "⚽", "🏐"],
    ["🐶", "🐱", "🐭"], ["✈️", "🚁", "🚢"], ["🌞", "🌍", "🌊"],
    ["🎈", "🎁", "🎂"], ["🌲", "🌳", "🌿"], ["🏠", "🏢", "🏬"],
    ["📕", "📘", "📗"], ["🐘", "🦓", "🦒"], ["🍔", "🍟", "🥤"],
    ["🚀", "🛰", "🌍"], ["🎤", "🎸", "🥁"], ["🏕", "🔥", "🛶"],
    ["🚴", "🏍", "🚂"], ["🎭", "🎨", "🎬"], ["🦄", "🐉", "🐲"],
    ["🛸", "🛶", "🚤"], ["🦅", "🦆", "🐧"], ["🍓", "🍒", "🍉"],
    ["🐳", "🐬", "🐟"], ["🎯", "🎳", "🎮"], ["⚔️", "🛡", "🏹"],
    ["🔬", "📡", "💡"], ["🌵", "🍀", "🌻"], ["🛵", "🚜", "🚛"],
    ["🦖", "🦕", "🐢"], ["📱", "💻", "🖥"], ["🎺", "🎻", "🥁"],
    ["🧩", "♟", "🎲"], ["📖", "📚", "📰"], ["🌈", "☁️", "🌙"],
    ["🎠", "🎢", "🎡"], ["🍕", "🌮", "🍣"], ["🍩", "🧁", "🍪"],
    ["🥦", "🥕", "🌽"], ["🦜", "🦢", "🦉"], ["🏖", "🏔", "🏜"],
    ["🛳", "🚁", "🚀"], ["🗻", "🏕", "🏝"], ["🛶", "🚤", "⛵"],
    ["🎭", "🎷", "🎺"], ["⚽", "🏈", "🏀"], ["🎹", "🎻", "🎷"],
    ["🦋", "🐞", "🐛"], ["🔑", "🗝", "💰"], ["⚓", "⛵", "🚢"],
    ["🚦", "🚥", "🛑"], ["🏯", "🏰", "🕌"], ["🦊", "🐻", "🐺"],
    ["💎", "📿", "💰"], ["🦎", "🐍", "🐸"], ["🏎", "🚜", "🚛"],
    ["🌼", "🌷", "💐"], ["🎃", "🧛", "👻"], ["🛷", "⛸", "🎿"],
    ["🦆", "🦉", "🦜"], ["🍯", "🍵", "🥛"], ["🧀", "🥖", "🥚"],
    ["🦔", "🐇", "🦨"], ["🛶", "🚤", "🚢"], ["🦜", "🦢", "🦆"],
    ["🚁", "🛫", "🚀"], ["🍎", "🍐", "🍊"], ["🦉", "🐦", "🦜"],
    ["🎂", "🍪", "🧁"], ["🦖", "🦕", "🐢"], ["🧸", "🪀", "🎲"],
    ["📻", "📺", "🎧"], ["🎃", "🎄", "🎁"], ["🥄", "🍴", "🔪"],
    ["💎", "🔮", "⚱"], ["🎩", "👑", "🎓"], ["🌜", "🌞", "🌛"],
    ["🍓", "🍒", "🍉"], ["🚕", "🚙", "🚐"], ["🦁", "🐯", "🐻"],
    ["🎷", "🎸", "🎺"], ["🏅", "🥇", "🥈"], ["📏", "📐", "📎"],
    ["🏡", "🏢", "🏰"], ["🎠", "🎪", "🎢"], ["📷", "🎥", "📽"],
    ["🌵", "🌴", "🎋"], ["🥇", "🥈", "🥉"], ["🍵", "☕", "🥤"],
    ["🛶", "🚤", "⛴"], ["🦌", "🐗", "🐘"], ["🌻", "🌺", "🌼"],
    ["📀", "💽", "💾"], ["🔮", "🪄", "🎩"], ["🥋", "🎽", "🥊"],
    ["🚜", "🚛", "🚚"], ["🎠", "🎢", "🎡"], ["📍", "🧭", "🗺"],
    ["🌞", "🌚", "🌕"], ["🍎", "🍑", "🍏"], ["🚴", "🛹", "🛼"],
    ["🕹", "🎮", "📟"], ["🚁", "🛩", "✈️"], ["🦕", "🦖", "🦣"],
    ["🥑", "🍠", "🥔"], ["📻", "🎧", "📱"], ["🎭", "🎟", "🎬"],
    ["🏆", "🏅", "🥇"], ["📦", "🎁", "🛍"], ["🎸", "🎷", "🎺"],
    ["🎠", "🎡", "🎢"], ["📖", "📚", "📜"], ["🛷", "⛸", "🎿"],
    ["🌄", "🏞", "🗻"], ["📱", "💻", "🖥"], ["🍕", "🍔", "🌭"],
    ["🐠", "🐟", "🐡"], ["📅", "🗓", "📆"], ["📞", "📟", "📠"],
    ["🍚", "🍙", "🍘"], ["📊", "📈", "📉"], ["🎤", "🎧", "📻"],
    ["🚑", "🚒", "🚓"], ["🔬", "🔭", "🧪"], ["🔔", "🎵", "🎶"],
    ["🧩", "🃏", "🎴"], ["🌜", "🌞", "🌛"], ["🍀", "🌹", "🌷"],
    ["🏞", "🏕", "🏔"], ["🏄", "🏊", "🚣"], ["🛒", "🛍", "🎁"],
    ["📯", "🎺", "🎷"], ["📹", "🎥", "📽"], ["🏗", "🏠", "🏢"],
    ["🔑", "🗝", "💰"], ["🦈", "🐋", "🐊"], ["🍵", "☕", "🥤"],
    ["🌵", "🌴", "🎋"], ["🏔", "🗻", "🏞"], ["📞", "📟", "📠"],
    ["🍀", "🌿", "☘"], ["🎖", "🏅", "🥇"], ["🏝", "🏜", "🏞"],
    ["🎠", "🎡", "🎢"], ["🍉", "🍓", "🍇"], ["🎙", "🎤", "🎧"]
];


const AboveMiddleBelowGame: React.FC = () => {
    const [question, setQuestion] = useState("");
    const [correctAnswer, setCorrectAnswer] = useState("");
    const [message, setMessage] = useState("");
    const [currentObjects, setCurrentObjects] = useState<string[]>([]);
    const [showImage, setShowImage] = useState(false);
    const modal = useRef<HTMLIonModalElement>(null);

    useEffect(() => {
        generateQuestion();
        document.title = "Above, Middle and Below – LKG Pre-Math Worksheet | Mama’s Guidance"; // Set page title
    }, []);

    const generateQuestion = () => {
        const randomSet = objectSets[Math.floor(Math.random() * objectSets.length)];
        setCurrentObjects(randomSet);

        const randomType = Math.random();
        let newQuestion = "";
        let correct = "";

        if (randomType < 0.33) {
            newQuestion = `Choose the object above ${randomSet[1]}.`;
            correct = randomSet[0];
        } else if (randomType < 0.66) {
            newQuestion = `Choose the object below ${randomSet[1]}.`;
            correct = randomSet[2];
        } else {
            newQuestion = `Choose the object in the middle.`;
            correct = randomSet[1];
        }

        setQuestion(newQuestion);
        setCorrectAnswer(correct);
    };

    const checkAnswer = (selected: string) => {
        if (selected === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                generateQuestion()
                setShowImage(false);
                setMessage("")
            }, 5000)
        } else {
            setShowImage(false);
            setMessage("❌ Oops! Try again.");
        }
    };

    return (
        <>
            <Helmet>
                <meta name="description" content='Help LKG learners understand the concepts of above, middle, and below with interactive activities on Mama’s Guidance—designed to enhance spatial awareness and positional understanding through fun, visual-based exercises.' />
            </Helmet>
            {
                showImage === false ?
                    <>
                        <div className="contentPart additionWord pickColor matchImage match-container" style={{ textAlign: "center", padding: "20px" }}>
                            <div className="showInfo" style={{ width: '80%' }} onClick={() => modal.current?.present()}><i className="fas fa-info-circle"></i></div>
                            <IonModal
                                ref={modal}
                                trigger="open-modal"
                                initialBreakpoint={1}
                                breakpoints={[0, 0.5, 0.75, 1]}
                                handleBehavior="cycle"
                                backdropDismiss={false}  // ✅ Prevents click-to-close
                                className="full-page-modal"
                            >
                                <IonContent className="ion-padding">
                                    <div style={{ textAlign: 'right', fontSize: '25px' }} onClick={() => modal.current?.dismiss()}><i className="fas fa-3a fa-times"></i></div>
                                    <h1>Above, Middle and Below</h1>

                                    <p>
                                        Teaching <strong>position words</strong> is essential for developing spatial awareness in early learners. This fun and colorful worksheet helps your LKG child understand and identify what is <strong>above</strong>, in the <strong>middle</strong>, and <strong>below</strong> using easy visuals and interactive activities.
                                    </p>

                                    <h2>📍 What Do Above, Middle, and Below Mean?</h2>
                                    <p>
                                        These terms describe the position of an object in relation to another.
                                        - <strong>Above</strong>: Positioned higher
                                        - <strong>Middle</strong>: Between or centered
                                        - <strong>Below</strong>: Positioned lower
                                        Understanding these helps children describe and comprehend where things are around them.
                                    </p>

                                    <h2>🧩 What’s in the Worksheet?</h2>
                                    <ul>
                                        <li>Picture-based activities with three stacked objects (<strong>e.g., balloons, books, animals</strong>)</li>
                                        <li>Circle the item that is in the <strong>middle, above, or below</strong></li>
                                        <li>Match objects with position words</li>
                                        <li>Coloring exercises to reinforce learning visually</li>
                                    </ul>

                                    <h2>🎯 Learning Objectives</h2>
                                    <ul>
                                        <li>Understand and use position vocabulary: <strong>above, middle, below</strong></li>
                                        <li>Build <strong>observation and comparison skills</strong></li>
                                        <li>Enhance directional understanding</li>
                                        <li>Strengthen <strong>early math and logical thinking</strong></li>
                                    </ul>

                                    <h2>👩‍🏫 How to Use the Worksheet</h2>
                                    <ul>
                                        <li>Look at the three pictures stacked vertically.</li>
                                        <li>Ask questions like <strong>“Which is in the middle?”</strong> or <strong>“What is below the red ball?”</strong></li>
                                        <li>Encourage your child to circle or color based on position.</li>
                                        <li>Use real-life objects (<strong>e.g., stacking cups or books</strong>) to demonstrate practically.</li>
                                    </ul>


                                    <h2>🔗 Related Topics</h2>
                                    <div>
                                        <IonItem routerLink="/lkg/mathematics/pre-math-concepts/long-short"
                                            routerDirection="none"
                                            lines="none"
                                            detail={true}>
                                            <IonLabel>Long - Short</IonLabel>
                                        </IonItem>
                                        <IonItem routerLink="/lkg/mathematics/pre-math-concepts/big-small"
                                            routerDirection="none"
                                            lines="none"
                                            detail={true}>
                                            <IonLabel>Big - Small</IonLabel>
                                        </IonItem>
                                        <IonItem routerLink="/lkg/mathematics/pre-math-concepts/full-empty"
                                            routerDirection="none"
                                            lines="none"
                                            detail={true}>
                                            <IonLabel>Full - Empty</IonLabel>
                                        </IonItem>
                                    </div>

                                    <h2>🧠 Why This Concept Is Important</h2>
                                    <p>
                                        Understanding <strong>position words</strong> like <strong>“above,” “middle,” and “below”</strong> lays the foundation for concepts in <strong>geometry, direction, and real-world communication</strong>. It also supports reading skills (top to bottom flow) and fine motor coordination.
                                    </p>

                                    <div className="btn hero-btn" onClick={() => modal.current?.dismiss()}>Close</div>
                                </IonContent>
                            </IonModal>
                            <article className="visually-hidden">
                                <h1>Above, Middle and Below</h1>

                                <p>
                                    Teaching <strong>position words</strong> is essential for developing spatial awareness in early learners. This fun and colorful worksheet helps your LKG child understand and identify what is <strong>above</strong>, in the <strong>middle</strong>, and <strong>below</strong> using easy visuals and interactive activities.
                                </p>

                                <h2>📍 What Do Above, Middle, and Below Mean?</h2>
                                <p>
                                    These terms describe the position of an object in relation to another.
                                    - <strong>Above</strong>: Positioned higher
                                    - <strong>Middle</strong>: Between or centered
                                    - <strong>Below</strong>: Positioned lower
                                    Understanding these helps children describe and comprehend where things are around them.
                                </p>

                                <h2>🧩 What’s in the Worksheet?</h2>
                                <ul>
                                    <li>Picture-based activities with three stacked objects (e.g., balloons, books, animals)</li>
                                    <li>Circle the item that is in the middle, above, or below</li>
                                    <li>Match objects with position words</li>
                                    <li>Coloring exercises to reinforce learning visually</li>
                                </ul>

                                <h2>🎯 Learning Objectives</h2>
                                <ul>
                                    <li>Understand and use position vocabulary: above, middle, below</li>
                                    <li>Build observation and comparison skills</li>
                                    <li>Enhance directional understanding</li>
                                    <li>Strengthen early math and logical thinking</li>
                                </ul>

                                <h2>👩‍🏫 How to Use the Worksheet</h2>
                                <ul>
                                    <li>Look at the three pictures stacked vertically.</li>
                                    <li>Ask questions like “Which is in the middle?” or “What is below the red ball?”</li>
                                    <li>Encourage your child to circle or color based on position.</li>
                                    <li>Use real-life objects (e.g., stacking cups or books) to demonstrate practically.</li>
                                </ul>


                                <h2>🔗 Related Topics</h2>
                                <div>
                                    <IonItem routerLink="/lkg/mathematics/pre-math-concepts/long-short"
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <IonLabel>Long - Short</IonLabel>
                                    </IonItem>
                                    <IonItem routerLink="/lkg/mathematics/pre-math-concepts/big-small"
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <IonLabel>Big - Small</IonLabel>
                                    </IonItem>
                                    <IonItem routerLink="/lkg/mathematics/pre-math-concepts/full-empty"
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <IonLabel>Full - Empty</IonLabel>
                                    </IonItem>
                                </div>

                                <h2>🧠 Why This Concept Is Important</h2>
                                <p>
                                    Understanding <strong>position words</strong> like <strong>“above,” “middle,” and “below”</strong> lays the foundation for concepts in geometry, direction, and real-world communication. It also supports reading skills (top to bottom flow) and fine motor coordination.
                                </p>
                            </article>
                            <h2>{question}</h2>
                            <div className="optionImageDiv" style={{ margin: "20px 0" }}>
                                {currentObjects.map((object, index) => (
                                    <div key={index} style={{ cursor: "pointer" }} onClick={() => checkAnswer(object)}>
                                        {object}
                                    </div>
                                ))}
                            </div>
                            <p>{message}</p>
                        </div>
                    </>
                    :
                    <>
                        <div className="contentPart showMiddle">
                            <img style={{ height: '150px' }} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                        </div>
                    </>
            }
        </>
    );
};

export default AboveMiddleBelowGame;
